export default {
  login: {
    welcome: 'Welcome Back',
    subtitle: 'Login to continue shopping',
    phonePlaceholder: 'Enter phone number',
    passwordPlaceholder: 'Enter password',
    showPassword: 'Show',
    hidePassword: 'Hide',
    loginButton: 'Login',
    registerButton: 'Free Register',
    title: 'Login',
    subtitle2: 'One-stop global shopping to earn rewards',
    logging: 'Logging in...',
    phoneRequired: 'Please enter phone number',
    passwordRequired: 'Please enter password',
    loginSuccess: 'Login successful',
    loginFailed: 'Login failed',
    loginError: 'Login error, please try again later'
  },
  register: {
    title: 'Create Account',
    subtitle: 'Join us and start your trading journey',
    username: 'Username',
    phone: 'Phone Number',
    loginPassword: 'Login Password',
    transactionPassword: 'Transaction Password',
    invitationCode: 'Invitation Code',
    usernamePlaceholder: 'Enter username',
    phonePlaceholder: 'Enter phone number',
    loginPasswordPlaceholder: 'Enter login password',
    transactionPasswordPlaceholder: 'Enter transaction password',
    invitationCodePlaceholder: 'Enter invitation code',
    registerButton: 'Register',
    hasAccount: 'Already have an account? Login',
    errorUsername: 'Please enter username',
    errorPhone: 'Please enter phone number',
    errorLoginPassword: 'Please enter login password',
    errorTransactionPassword: 'Please enter transaction password',
    errorInviteCode: 'Please enter invitation code',
    registerSuccess: 'Registration successful'
  },
  tabbar: {
    home: 'Home',
    purchase: 'Order Records',
    grabbing: 'Place Order',
    kefu: 'Support',
    my: 'My Account'
  },
  home: {
    orderCount: 'Order Count',
    upgradeAmount: 'Upgrade Amount',
    recharge: 'Recharge',
    withdraw: 'Withdraw',
    team: 'Team Management',
    commission: 'Get Commission',
    newProducts: 'New Arrivals',
    newProductsDesc: 'Latest styles from the new season and future collections.',
    buyNow: 'Buy Now',
    nowAvailable: 'NOW AVAILABLE',
    nowAvailableDesc: 'Get dressed for wedding season, pack for your next getaway and update your closet without commitment. With our new Borrow program, you can try to latest trends and stick to your budget, no subscription required.',
    footerTitle: 'Desigual.com',
    footerFollow: "FOLLOW US {'@'}Desigual.com and SHARE YOUR FAVE Desigual.com LOOKS!",
    footerShop: 'SHOP OUR FEED'
  },
  purchase: {
    all: 'All',
    pending: 'Pending',
    completed: 'Completed',
    frozen: 'Frozen',
    balance: 'Account Balance',
    orderTime: 'Order Time',
    orderId: 'Order ID',
    totalAmount: 'Total Amount',
    commission: 'Commission',
    expectedReturn: 'Expected Return',
    submitOrder: 'Submit Order',
    orderCompleted: 'Order Completed',
    loading: 'Loading...',
    noData: 'No order data',
    noMore: 'No more',
    orderSuccess: 'Order Success',
    orderNumber: 'Order Number',
    rating: 'Rating',
    notSubmit: 'Not Submit',
    submitNow: 'Submit Now',
    submitting: 'Submitting...',
    submitFailed: 'Submit Failed',
    grabOrderFailed: 'Order failed, please try again later',
    getOrderInfoFailed: 'Failed to get order details',
    submitOrderFailed: 'Submit failed, please try again later'
  },
  common: {
    home: 'Home',
    about: 'About',
    contact: 'Contact Us',
    purchase: 'Order Records',
    grabbing: 'Place Order',
    my: 'My',
    login: 'Login',
    register: 'Register',
    kefu: 'Customer Service',
    loadDataError: 'Failed to load data, please try again later',
    success: 'Success',
    failed: 'Failed',
    submitSuccess: 'Submit Successfully',
    submitFailed: 'Submit Failed',
    submitting: 'Submitting...'
  },
  grabbing: {
    accountAmount: 'Account Amount',
    accountBalance: 'Account Balance',
    getCommission: 'Get Commission',
    ordersGrabbedToday: 'Orders Grabbed',
    orderCount: 'Order Count',
    operationSteps: 'Operation Steps',
    step1: '1. Click the start task button and complete the task according to the prompts',
    step2: '2. After completing the task, you can settle the commission to the balance',
    grabOrder: 'Grab Order',
    pleaseWait: 'Please Wait',
    grabSuccess: 'Grab Success',
    grabTime: 'Grab Time',
    grabNumber: 'Grab Number',
    orderTotal: 'Order Total',
    commission: 'Commission',
    expectedReturn: 'Expected Return',
    rating: 'Rating',
    notSubmit: 'Not Submit',
    submitNow: 'Submit Now',
    submitting: 'Submitting...'
  },
  kefu: {
    title: 'Support',
    intro: {
      line1: 'If you have any questions or need help,',
      line2: 'Please contact our online customer service for assistance'
    },
    serviceTime: {
      label: 'Service Time',
      text: 'Your Dedicated Support',
      online: 'Online'
    },
    contact: {
      title: 'Contact',
      name: 'Online',
      status: 'Consultation',
      feature1: 'Instant Response',
      feature2: 'Professional Service',
      button: 'Contact'
    },
    faq: {
      title: 'FAQ',
      rechargeQuestion: 'How to recharge?',
      rechargeAnswer: 'You can recharge through our secure payment gateway. Go to My Account > Recharge and follow the instructions.',
      withdrawQuestion: 'How to withdraw?',
      withdrawAnswer: 'Withdrawals can be made through My Account > Withdraw. Please ensure your account is verified.',
      minRechargeQuestion: 'What is the minimum recharge amount?',
      minRechargeAnswer: 'The minimum recharge amount is ${currency}68.',
      withdrawTimeQuestion: 'How long does withdrawal take?',
      withdrawTimeAnswer: 'Withdrawals are usually processed within 24 hours.',
      securityQuestion: 'Is my information secure?',
      securityAnswer: 'Yes, we use industry-standard encryption to protect your personal and financial information.'
    }
  },
  my: {
    inviteCode: 'Invite Code',
    copy: 'COPY',
    copySuccess: 'Copied successfully',
    copyFailed: 'Copy failed',
    online: 'Online',
    accountBalance: 'Account Balance',
    balance: 'Balance',
    accountBalanceTrend: 'Account Balance',
    todayCommission: 'Today Commission',
    totalCommission: 'Total Commission',
    today: 'Today',
    total: 'Total',
    todayOrders: 'Orders Grabbed',
    orderCount: 'Order Count',
    recharge: 'Recharge',
    withdraw: 'Withdraw',
    rechargeRecord: 'Recharge Record',
    withdrawRecord: 'Withdraw Record',
    accountDetails: 'Account Details',
    receivingAccount: 'Receiving Account',
    bankAccount: 'Bank Account',
    bankAccountDesc: 'Bank Account',
    usdt: 'USDT',
    usdtDesc: 'USDT Address',
    connect: 'Connect',
    teamManagement: 'Team Management',
    viewTeam: 'View Team',
    changePassword: 'Change Password',
    changeWithdrawPassword: 'Change Withdraw Password',
    passwordSettings: 'Password Settings',
    logout: 'Logout',
    signOut: 'Sign Out',
    version: 'Version'
  },
  changePasswordPage: {
    currentPassword: 'Current Login Password',
    currentPasswordPlaceholder: 'Enter current password',
    newPassword: 'New Login Password',
    newPasswordPlaceholder: 'Enter new password',
    confirmPassword: 'Confirm Login Password',
    confirmPasswordPlaceholder: 'Confirm new password',
    notice: 'Login password is used for account login. Password must be at least 6 characters and include letters and numbers for security.',
    updateButton: 'Update Login Password',
    errorOldPassword: 'Please enter current password',
    errorNewPassword: 'Please enter new password',
    errorConfirmPassword: 'Please confirm new password',
    errorPasswordMismatch: 'Passwords do not match',
    errorPasswordLength: 'Password must be at least 6 characters',
    errorPasswordFormat: 'Password must include letters and numbers'
  },
  changeWithdrawPasswordPage: {
    currentPassword: 'Current Withdraw Password',
    currentPasswordPlaceholder: 'Enter current withdraw password',
    newPassword: 'New Withdraw Password',
    newPasswordPlaceholder: 'Enter new withdraw password',
    confirmPassword: 'Confirm Withdraw Password',
    confirmPasswordPlaceholder: 'Confirm new withdraw password',
    notice: 'Withdraw password is used for fund withdrawal operations. Password must be at least 6 characters and include letters and numbers for security.',
    updateButton: 'Update Withdraw Password',
    errorOldPassword: 'Please enter current withdraw password',
    errorNewPassword: 'Please enter new withdraw password',
    errorConfirmPassword: 'Please confirm new withdraw password',
    errorPasswordMismatch: 'Passwords do not match',
    errorPasswordLength: 'Password must be at least 6 characters',
    errorPasswordFormat: 'Password must include letters and numbers'
  },
  details: {
    loading: 'Loading...',
    noRecords: 'No records',
    noMore: 'No more data',
    time: 'Time',
    type: 'Type',
    amount: 'Amount',
    balance: 'Balance',
    remark: 'Remark',
    type0: 'Other',
    type1: 'Recharge',
    type2: 'Withdraw',
    type3: 'Transaction',
    type4: 'Order Commission',
    type5: 'Subordinate Commission',
    type8: 'Withdraw Rejected'
  },
  rechargeRecord: {
    offline: 'Offline Recharge',
    online: 'Online Recharge',
    loading: 'Loading...',
    noRecords: 'No records',
    orderNo: 'Order No.',
    rechargeAmount: 'Recharge Amount',
    rechargeTime: 'Recharge Time',
    payMethod: 'Payment Method',
    rechargeStatus: 'Recharge Status',
    noMore: 'No more data',
    statusPending: 'Pending',
    statusApproved: 'Approved',
    statusFailed: 'Failed',
    statusEmpty: ''
  },
  withdrawRecord: {
    loading: 'Loading...',
    noRecords: 'No records',
    orderNo: 'Order No.',
    withdrawAmount: 'Withdrawal Amount',
    withdrawTime: 'Withdrawal Time',
    withdrawAddress: 'Withdrawal Address',
    withdrawStatus: 'Withdrawal Status',
    noMore: 'No more data',
    statusPending: 'Withdrawing',
    statusApproved: 'Withdrawal Successful',
    statusFailed: 'Withdrawal Failed',
    statusEmpty: ''
  },
  withdraw: {
    title: 'Withdraw',
    method: 'Withdrawal Method',
    methodSubtitle: 'Please select your withdrawal method',
    bankInfo: 'Bank Account Information',
    bankName: 'Bank Name',
    accountHolder: 'Account Holder',
    bankCard: 'Bank Card',
    amount: 'Withdrawal Amount',
    balance: 'Balance',
    withdrawAll: 'Withdraw All',
    paymentPassword: 'Payment Password',
    passwordPlaceholder: 'Please enter fund password',
    principal: 'Principal Amount',
    serviceFee: 'Service Fee',
    netAmount: 'Net Amount',
    notice: '*Please verify the payment information carefully',
    withdrawButton: 'Withdraw',
    walletAddress: 'Wallet Address',
    walletAddressSubtitle: 'Please enter wallet address'
  },
  recharge: {
    title: 'Recharge',
    amount: 'Recharge Amount',
    amountSubtitle: 'Please enter the amount you want to recharge',
    quickSelect: 'Quick Select',
    rechargeNow: 'Recharge Now',
    selectPayment: 'Select Payment Method',
    selectPaymentSubtitle: 'Please select your preferred payment method',
    cancel: 'Cancel',
    confirm: 'Confirm',
    crypto: 'Cryptocurrency',
    bank: 'Bank Transfer',
    paymentRange: 'Minimum: {symbol}{minAmount} - Maximum: {symbol}{maxAmount}',
    rechargeFailed: 'Recharge failed',
    paymentInfo: 'Payment Information',
    usercode: 'USDT Address',
    uploadScreenshot: 'Please upload payment screenshot',
    clickToUpload: 'Click to upload screenshot',
    copySuccess: 'Copied successfully',
    copyFailed: 'Copy failed',
    uploadScreenshotRequired: 'Please upload payment screenshot',
    submit: 'Submit',
    submitting: 'Submitting...',
    submitSuccess: 'Submitted successfully',
    submitFailed: 'Submission failed'
  },
  bindUsdt: {
    title: 'Bind USDT',
    cardTitle: 'USDT Address',
    cardSubtitle: 'Enter your USDT wallet address',
    walletAddress: 'Wallet Address',
    walletAddressPlaceholder: 'Please enter USDT wallet address',
    networkType: 'Network Type',
    networkTypePlaceholder: 'Please select network type',
    withdrawPassword: 'Withdraw Password',
    withdrawPasswordPlaceholder: 'Please enter withdraw password',
    trc20: 'TRC20',
    trc20Network: 'TRC20 Network',
    erc20: 'ERC20',
    erc20Network: 'ERC20 Network',
    securityNotice: 'Security Notice',
    securityText1: '• Your USDT address is encrypted and securely stored',
    securityText2: '• Only you can view and modify this information',
    securityText3: '• Please ensure all information is accurate',
    buttonText: 'Save',
    buttonSubtitle: 'Bind USDT Address',
    errorWalletAddress: 'Please enter wallet address',
    errorNetworkType: 'Please select network type',
    errorWithdrawPassword: 'Please enter withdraw password'
  },
  team: {
    title: 'Team Management',
    level1: 'Level 1 Team',
    level2: 'Level 2 Team',
    level3: 'Level 3 Team',
    level1Members: 'Level 1 Team Members',
    level2Members: 'Level 2 Team Members',
    level3Members: 'Level 3 Team Members',
    totalMembers: 'Total Members',
    totalCommission: 'Total Commission',
    members: 'Members',
    orders: 'Orders',
    commission: 'Commission',
    noMembers: 'No Members',
    loading: 'Loading...',
    noMore: 'No more data'
  },
  bindBank: {
    title: 'Bind Bank Card',
    cardTitle: 'Bank Information',
    cardSubtitle: 'Select your bank and enter account details',
    bankName: 'Bank Name',
    bankNamePlaceholder: 'Enter bank name',
    cardNumber: 'Card Number',
    cardNumberPlaceholder: 'Enter card number',
    realName: 'Real Name',
    realNamePlaceholder: 'Enter real name',
    withdrawPassword: 'Withdraw Password',
    withdrawPasswordPlaceholder: 'Enter withdraw password',
    securityNotice: 'Security Notice',
    securityText1: '• Your bank information is encrypted and securely stored',
    securityText2: '• Only you can view and modify this information',
    securityText3: '• Please ensure all information is accurate',
    buttonText: 'Save Information',
    buttonSubtitle: 'Bind Bank Account',
    errorBankName: 'Please enter bank name',
    errorCardNumber: 'Please enter card number',
    errorRealName: 'Please enter real name',
    errorWithdrawPassword: 'Please enter withdraw password'
  }
}
